module.exports = __webpack_public_path__ + "assets/img/chronicleImg-aa93eabd.png";